import { useState, useEffect } from "react";
import axios from "axios";
import { ChartBar, Calculator, Lightning, Clock } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UserStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/user/stats`);
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching user stats:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading || !stats || stats.total === 0) return null;

  return (
    <div className="bg-white border border-[#171717] rounded-none p-6 mb-8 shadow-[4px_4px_0px_0px_rgba(23,23,23,1)]" data-testid="user-stats-panel">
      <div className="flex items-center gap-3 mb-4">
        <ChartBar size={24} weight="regular" className="text-[#8B1A1A]" />
        <h3 className="text-lg font-semibold text-[#0A0A0A]" style={{ fontFamily: 'Playfair Display, serif' }}>
          Tus estadisticas
        </h3>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <div className="bg-[#F4F4F0] p-3 text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <Calculator size={16} className="text-[#8B1A1A]" />
          </div>
          <span className="font-mono text-xl font-bold text-[#0A0A0A] block" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
            {stats.total}
          </span>
          <p className="text-[10px] uppercase tracking-[0.15em] text-[#525252]">Calculos</p>
        </div>
        
        <div className="bg-[#F4F4F0] p-3 text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <Lightning size={16} className="text-[#8B1A1A]" />
          </div>
          <span className="font-mono text-xl font-bold text-[#0A0A0A] block" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
            {stats.con_ia}
          </span>
          <p className="text-[10px] uppercase tracking-[0.15em] text-[#525252]">Con IA</p>
        </div>
        
        {stats.cuantia_stats && (
          <>
            <div className="bg-[#F4F4F0] p-3 text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Clock size={16} className="text-[#8B1A1A]" />
              </div>
              <span className="font-mono text-lg font-bold text-[#0A0A0A] block" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                {Math.round(stats.cuantia_stats.media || 0).toLocaleString('es-ES')}€
              </span>
              <p className="text-[10px] uppercase tracking-[0.15em] text-[#525252]">Cuantia media</p>
            </div>
            
            <div className="bg-[#F4F4F0] p-3 text-center">
              <span className="font-mono text-lg font-bold text-[#8B1A1A] block" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                {Math.round(stats.cuantia_stats.total_honorarios || 0).toLocaleString('es-ES')}€
              </span>
              <p className="text-[10px] uppercase tracking-[0.15em] text-[#525252]">Total honorarios</p>
            </div>
          </>
        )}
      </div>
      
      {stats.por_tipo.length > 0 && (
        <div className="border-t border-[#E5E5E2] pt-3">
          <p className="text-xs uppercase tracking-[0.15em] text-[#525252] mb-2">Procedimientos mas consultados</p>
          <div className="space-y-1">
            {stats.por_tipo.slice(0, 3).map((item, idx) => (
              <div key={idx} className="flex justify-between items-center text-sm">
                <span className="text-[#0A0A0A] truncate mr-2" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                  {item.procedimiento}
                </span>
                <span className="font-mono text-xs text-[#525252] shrink-0" style={{ fontFamily: 'IBM Plex Mono, monospace' }}>
                  {item.count}x
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserStats;
